var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseImg',{staticClass:"mx-auto lg:mx-0",attrs:{"src":require('@images/public/tutor-list/tutor-list-header.webp'),"sizes":{lg:['397',225], xs: ['220','125']}}})}
var staticRenderFns = []

export { render, staticRenderFns }